import script from "./SidebarExpandable.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarExpandable.vue?vue&type=script&setup=true&lang=js"

import "./SidebarExpandable.vue?vue&type=style&index=0&id=c574420e&scoped=true&lang=css"
import "./SidebarExpandable.vue?vue&type=style&index=1&id=c574420e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c574420e"]])

export default __exports__